import * as Sentry from '@sentry/browser'
Sentry.init({
  dsn: 'https://d0eafed42bfc49bd95b1287adfacfe6e@o1037737.ingest.sentry.io/6005818',

  release: null,

  integrations: [Sentry.browserTracingIntegration()],

  ignoreErrors: [/Can't find variable: gmo/],

  sampleRate: 0.01,
  tracesSampleRate: 0.005,
})
